import type { UseCase } from '@/core/shared'
import type { RemoveUserFromAccessConfig, AccessConfigRepository } from '../domain'

export const removeUserFromAccessConfig: UseCase<AccessConfigRepository, 'removeUserFromAccessConfig'> = repository => {
  return async (removeUserFromAccessConfig: RemoveUserFromAccessConfig) => {
    await repository.removeUserFromAccessConfig(removeUserFromAccessConfig)
  }
}
